var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"variant":_vm.variant,"show":""}},[_c('i',{staticClass:"fas fa-notes-medical mr-2"}),_vm._t("default",function(){return [_vm._v(" No Alert Data was passed. ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }